import { SelectOption } from 'models/formSingleSelectField';
import { createContext, useContext } from 'react';
import { DocumentRejection } from '../BusinessVerificationV3Models';

export type ProductServiceItem = { id: number; name: string; description?: string | null };

type TVerificationContext = {
    selectOptions?: VerificationDropdownOptions;
    rejectedDocuments?: DocumentRejection;
    productServices?: ProductServiceItem[];
};

export type OpenedDocument = {
    id: number;
    internalName: string;
};

export type VerificationDropdownOptions = {
    entityTypes?: SelectOption[];
    regionsOfOperation?: SelectOption[];
    availableCountries?: CountryOption[];
    accountPurposes?: SelectOption[];
    businessActivities?: SelectOption[];
    occupations?: SelectOption[];
    fundingSources?: SelectOption[];
    transactionVolumes?: SelectOption[];
    monthlyUsdEquivalents?: SelectOption[];
    uboReportingExemptions?: SelectOption[];
    openedDocumentsList?: OpenedDocument[];
};

type CountryOption = {
    id: number;
    countryName: string;
    isoCode: string;
    iso2: string;
    states: { id: number; stateProvinceName: string; ansiCode: string }[] | null;
};

export const VerificationContext = createContext<TVerificationContext | null>(null);

export const useVerificationContext = () => {
    const context = useContext(VerificationContext);
    if (!context) throw new Error('useVerificationContext used outside provider');
    return context;
};
